var module = angular.module('octopusApp.projects');

module.directive('projectTriggerEditor', function() {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'areas/projects/triggers/trigger_editor.html'
  };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/triggers/project_trigger_editor.js
// module id = 981800848858808
// module chunks = 1